import React, { memo, useContext } from 'react';

import classNames from 'classnames';

import { UiButton } from '@shared/ui';

import cls from './AdditionallyCard.module.css';
import { useAdditionallyCard } from './useAdditionallyCard';
import { Input } from '../../../../components/newUI/Input/Input';
import { MeasuremntsContext } from '../../Context/MeasuremntsContext';

export const AdditionallyCard = memo(({ cardId }) => {
    const { onCloseCard, additionallyCard, onInput } = useAdditionallyCard(cardId);

    const { errorsInput } = useContext(MeasuremntsContext);

    if (!cardId) return null;

    return (
        <div className={classNames(cls.AdditionallyCard)}>
            <div className={cls.closeCard}>
                <UiButton
                    onClick={() => onCloseCard(cardId)}
                    className={cls.buttonClose}
                    variant="icon"
                    startIcon={
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M3.66098 3.66066C3.81725 3.50443 4.02918 3.41667 4.25015 3.41667C4.47112 3.41667 4.68304 3.50443 4.83931 3.66066L8.00015 6.82149L11.161 3.66066C11.2379 3.58107 11.3298 3.51758 11.4315 3.47391C11.5331 3.43023 11.6425 3.40724 11.7531 3.40628C11.8638 3.40532 11.9735 3.4264 12.0759 3.46831C12.1784 3.51021 12.2714 3.57208 12.3496 3.65033C12.4279 3.72857 12.4898 3.82161 12.5317 3.92403C12.5736 4.02644 12.5947 4.13618 12.5937 4.24682C12.5927 4.35747 12.5697 4.46682 12.5261 4.56849C12.4824 4.67016 12.4189 4.76212 12.3393 4.83899L9.17848 7.99982L12.3393 11.1607C12.4911 11.3178 12.5751 11.5283 12.5732 11.7468C12.5713 11.9653 12.4837 12.1743 12.3292 12.3288C12.1747 12.4833 11.9656 12.571 11.7471 12.5729C11.5287 12.5748 11.3181 12.4908 11.161 12.339L8.00015 9.17816L4.83931 12.339C4.68215 12.4908 4.47164 12.5748 4.25315 12.5729C4.03465 12.571 3.82564 12.4833 3.67113 12.3288C3.51663 12.1743 3.42898 11.9653 3.42709 11.7468C3.42519 11.5283 3.50918 11.3178 3.66098 11.1607L6.82181 7.99982L3.66098 4.83899C3.50476 4.68272 3.41699 4.47079 3.41699 4.24982C3.41699 4.02885 3.50476 3.81693 3.66098 3.66066Z"
                                fill="#252733"
                            />
                        </svg>
                    }
                />
            </div>
            <Input
                onChange={onInput}
                inputName="name"
                value={additionallyCard.name}
                required
                label={i18next.t('AdditionallyCard.return.InputName.label')}
                placeholder={i18next.t('AdditionallyCard.return.InputName.placeholder')}
                type="text"
                error={errorsInput.additionallyName[cardId]}
            />
            <div className={cls.secondRow}>
                <Input
                    onChange={onInput}
                    inputName="value"
                    value={additionallyCard.value}
                    classes={cls.column}
                    label={i18next.t('AdditionallyCard.return.InputValue.label')}
                    placeholder="0"
                    type="measurements"
                />
                <Input
                    onChange={onInput}
                    inputName="unit"
                    value={additionallyCard.unit}
                    classes={cls.column}
                    label={i18next.t('AdditionallyCard.return.InputUnit.label')}
                    placeholder={i18next.t('AdditionallyCard.return.InputUnit.placeholder')}
                />
            </div>
        </div>
    );
});
